<template>
    <div class="header-wrapper">
        <header class="header-content">
            <!-- <div class="left" @click="goBack">
                <img :src="require(`@/assets/images/icons/back.png`)" alt="" height="24px" />
            </div> -->
            <div class="center h_logo" @click="goHome">
                <img :src="require('@/assets/images/front_bi.png')" alt="" height="31px" />
            </div>
            <div class="right" @click="goBack">
                <img :src="require(`@/assets/images/icons/close.png`)" alt="" height="24px" />
            </div>
        </header>
    </div>
</template>
<script>
export default {
    name: 'EvalHeader',
    props: {
        rightButtonHandler: {
            type: Function,
        },
        pageName: {
            type: String,
            required: false,
        },
        goHomeHandler: {
            type: Function,
            required: false,
        },
    },
    computed: {
        me() {
            return this.$store.getters.me
        },
    },
    methods: {
        goBack() {
            if (this.rightButtonHandler) {
                this.rightButtonHandler()
            }
        },
        goHome() {
            // part1 입력이 끝나지않은 유저는 본 화면에서 빠져나갈 수 없어야한다.
            // 설사 빠져나가더라도 apply/form 화면으로 redirect 되어야한다.
            console.log('goHome')
            if (this.goHomeHandler) {
                return this.goHomeHandler()
            }
            this.$router.push('/')
        },
    },
}
</script>

<style lang="scss" scoped>
.header-wrapper {
    width: 100%;
    height: 56px;
    background-color: white;
    position: fixed;
    top: 0;
    z-index: 2;

    .header-content {
        width: inherit;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 12px;
    }

    .left {
        width: 24px;
        height: 24px;
        position: absolute;
        left: 12px;
        top: 16px;
    }

    .right {
        width: 24px;
        height: 24px;
        position: absolute;
        right: 12px;
        top: 16px;
    }
}
</style>
